/* eslint-disable no-unused-vars */
export const HOURS_PER_DAY = 24
export const MINUTES_PER_HOUR = 60
export const TIME_FORMAT = 'HH:mm'

export const MIN_HEIGHT_HIDE_DETAIL = 60

export const MIN_HEIGHT_EVENT = 30

export const BORDER_WEEKLY_CELL = 1

export const EVENT_VERTICAL_SPACING = 12

export enum DAYS_OF_WEEK {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday'
}
export enum DAYS_OF_WEEK_SHORTEN {
  Monday = 'Mon',
  Tuesday = 'Tue',
  Wednesday = 'Wed',
  Thursday = 'Thur',
  Friday = 'Fri',
  Saturday = 'Sat',
  Sunday = 'Sun'
}
export enum HOUR_OF_DAY {
  '07:00' = '07:00',
  '08:00' = '08:00',
  '09:00' = '09:00',
  '10:00' = '10:00',
  '11:00' = '11:00',
  '12:00' = '12:00',
  '13:00' = '13:00',
  '14:00' = '14:00',
  '15:00' = '15:00',
  '16:00' = '16:00',
  '17:00' = '17:00',
  '18:00' = '18:00',
  '19:00' = '19:00',
  '20:00' = '20:00',
  '21:00' = '21:00',
  '22:00' = '22:00',
  '23:00' = '23:00',
  '24:00' = '24:00'
}
export enum EVENT_TYPES {
  TEACHING = 'TEACHING',
  BUSY = 'BUSY',
  HOLIDAY = 'HOLIDAY',
  OTHER = 'OTHER',
  LIVE_ONLINE = 'LIVE_ONLINE',
  INACTIVE = 'INACTIVE'
}

export enum FORMAT_DATE_CARLENDA {
  MONTH_AND_WEEK = 'MMMM YYYY',
  DATE = 'DD'
}
export enum LEARNING_MODE {
  ONLINE = 'ONLINE',
  LIVE_ONLINE = 'LIVE_ONLINE',
  OFFLINE = 'OFFLINE',
  CASE_STUDY = 'CASE_STUDY',
  HOLIDAY = 'HOLIDAY',
  OVERDUE = 'OVERDUE',
  TEST = 'TEST',
  KEY_BEFORE_CONTENT = 'KEY_BEFORE_CONTENT'
}

export enum CALENDAR_TYPE {
  OPS = 'OPS',
  LMS = 'LMS'
}

export const FORMAT_DATETIME = 'DD/MM/YYYY, HH:mm'
export enum STATUS_NORM {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED'
}
